/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/offcanvas';
import './components/delay-search-queries';
import './components/video';
import './components/footer-menus';
import './components/foundation.app';
import './components/accessibility';
import './components/lazy.jquery';
import './components/copy-link';
import './components/wp-gallery-swiper';
import './components/vacancies';
import './components/sticky-header-scroll';


$('.ginput_container_fileupload input[type="file"]').each( function() {
	$('<span class="uploaded">Geen bestand gekozen</span>').insertAfter($(this));
});

$('.ginput_container_fileupload input[type="file"]').on('change', function(e) {
	var files = e.target.files;
	if ( files !== undefined ) {
		$(this).next( '.uploaded' ).text( files[0].name );
	}
});